import { Component, OnInit } from '@angular/core';
import { delay, forkJoin, map, of, switchMap } from 'rxjs';
import { FilterModel } from 'src/app/shared/components/split-button-filter/split-button-filter.component';
import { ModalService } from 'src/app/shared/services/modal.service';
import { RevenueInvoiceEventService } from 'src/app/shared/services/revenue-invoice-event.service';
import { RevenuePaymentMethodService } from 'src/app/shared/services/revenue-payment-method.service';
import { ReceitaFormComponent } from '../receita-form/receita-form.component';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { NotifyService } from 'src/app/shared/services/notify.service';
import { Filter } from 'src/app/shared/models/filter';

@Component({
  selector: 'app-receita-pesquisa',
  templateUrl: './receita-pesquisa.component.html',
  styleUrls: ['./receita-pesquisa.component.scss']
})
export class ReceitaPesquisaComponent {

  public filter: Filter = new Filter().size(10);

  constructor() {}

}

